import React from "react";
import * as S from "./styles";
export var DownSolidCaret = function DownSolidCaret(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 9",
    "aria-hidden": "true"
  }, e), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.5L0 0.5H12L6 7.5Z",
    fill: "currentcolor"
  }));
};